
export default {
    getCursos(state) {
        return state.cursos
    },
    getCurso(state) {
        return state.curso
    },
}